import * as actions from '@r1-frontend/bp42/actions';
import { BP42Action } from '@r1-frontend/bp42/constants/actions';
import initialState, { BP42InitialState } from '@r1-frontend/bp42/reducer/initialState';

import { InferValueTypes } from '@r1-frontend/shared/types/Redux';

export type BP42Actions = ReturnType<InferValueTypes<typeof actions>>

const reducer = (state: BP42InitialState, action: BP42Actions): BP42InitialState => {
    switch (action.type) {
        case BP42Action.Initialized:
        case BP42Action.Initialization: {
            return {
                ...state,
                ...action.payload,
                _initialized: true,
            };
        }
        case BP42Action.Finalization: {
            return { ...initialState };
        }

        case BP42Action.Loading: {
            return {
                ...state,
                _loading: action.payload.state,
            };
        }

        case BP42Action.OpenPopup: {
            return {
                ...state,
                _popup: { open: true },
            };
        }
        case BP42Action.ClosePopup: {
            return {
                ...state,
                _popup: { open: false },
            };
        }

        // @todo will be implemented if necessary
        // case BP42Action.SetProduct:
        // case BP42Action.RemoveProduct: {
        //     return { ...state };
        // }
        case BP42Action.StartedTyping: {
            return {
                ...state,
                _startedTyping: true,
            };
        }
        case BP42Action.FillName: {
            return {
                ...state,
                formData: {
                    ...state.formData,
                    name: {
                        ...action.payload,
                    },
                },
            };
        }
        case BP42Action.FillPhone: {
            return {
                ...state,
                formData: {
                    ...state.formData,
                    phone: {
                        ...action.payload,
                    },
                },
            };
        }
        case BP42Action.SetSubmitResult: {
            return {
                ...state,
                _submitResult: {
                    ...action.payload,
                },
            };
        }
        case BP42Action.FlushSubmitResult: {
            return {
                ...state,
                _submitResult: initialState._submitResult,
            };
        }
        default: {
            return { ...state };
        }
    }
};

export default reducer;
